import api from './api';
import type { AttendanceCorrectionRequest, CreateCorrectionRequest } from '../types/attendanceCorrection';

export const attendanceCorrectionService = {
  // 修正申請一覧取得
  async getRequests(): Promise<AttendanceCorrectionRequest[]> {
    const response = await api.get<AttendanceCorrectionRequest[]>('/attendance/corrections');
    return response.data;
  },

  // 修正申請作成
  async createRequest(data: CreateCorrectionRequest): Promise<{ message: string; request: AttendanceCorrectionRequest }> {
    const response = await api.post<{ message: string; request: AttendanceCorrectionRequest }>('/attendance/corrections', data);
    return response.data;
  },

  // 修正申請承認
  async approveRequest(id: number): Promise<{ message: string }> {
    const response = await api.put<{ message: string }>(`/attendance/corrections/${id}/approve`);
    return response.data;
  },

  // 修正申請却下
  async rejectRequest(id: number): Promise<{ message: string }> {
    const response = await api.put<{ message: string }>(`/attendance/corrections/${id}/reject`);
    return response.data;
  },

  // 修正申請削除（取下げ）
  async deleteRequest(id: number): Promise<{ message: string }> {
    const response = await api.delete<{ message: string }>(`/attendance/corrections/${id}`);
    return response.data;
  },
};
